<template> 
	<div v-if="avoidDefaultClass">
		<slot name="rowContent">rowContent</slot>
	</div>
	<div class="callBoxRow" :class="optionalClass" v-else-if="optionalClass">
		<slot name="rowContent">rowContent</slot>
	</div>
	<div class="callBoxRow" v-else>
		<slot name="rowContent">rowContent</slot>
	</div>
</template>
<script type="text/javascript">
	export default {
    name: 'callDetailsRow',
    props: ['avoidDefaultClass', 'optionalClass']
  }
</script>